import { useMutation } from '@tanstack/react-query'
import {
  type InferRequestType,
  type InferResponseType,
  parseResponse,
} from 'hono/client'
import { type PortalAiClient, usePortalAiClient } from '#src/api/ai.ts'

type GenerateAiSkillMetadataPost =
  PortalAiClient['api']['generateAiSkillMetadata']['$post']

export type GenerateAiSkillMetadataContent =
  InferRequestType<GenerateAiSkillMetadataPost>['json']['content']
export type GenerateAiSkillMetadataResponse = InferResponseType<
  GenerateAiSkillMetadataPost,
  200
>

export function useGenerateAiSkillMetadataMutation() {
  const client = usePortalAiClient()

  return useMutation({
    mutationKey: ['seen-api', 'generateAiSkillMetadata'] as const,
    mutationFn: async (
      content: GenerateAiSkillMetadataContent
    ): Promise<GenerateAiSkillMetadataResponse> =>
      parseResponse(
        client.api.generateAiSkillMetadata.$post({ json: { content } })
      ),
  })
}
